const DojoWebPosResult = require('@/lib/PaymentMethods/Dojo/Enums/DojoWebPosResult');
const DojoWebPosTransactionType = require('@/lib/PaymentMethods/Dojo/Enums/DojoWebPosTransactionType');
const { fromMinorUnit, toMinorUnit } = require('@/functions/math');

class DojoWebPosTransaction {
    /**
     * DojoTransaction holds all the information about a SALE or REFUND request made to the Dojo API. As the transaction
     * is processed by Dojo we update this object to store the current state.
     *
     * @param {number} amountMajorUnits
     */
    constructor(amountMajorUnits) {
        if (!amountMajorUnits || typeof amountMajorUnits !== 'number') {
            throw new Error('DojoWebPosTransaction requires amount to be a number');
        }

        /**
         * @type {string}
         */
        this.type = DojoWebPosTransactionType.SALE;

        if (amountMajorUnits < 0) {
            this.type = DojoWebPosTransactionType.REFUND;
        }

        /**
         * @type {number}
         */
        this.amountMajorUnits = amountMajorUnits;

        /**
         * @type {number}
         */
        this.amountMinorUnits = Math.abs(toMinorUnit(amountMajorUnits));

        /**
         * @type {number}
         */
        this.gratuityMajorUnits = 0;

        /**
         * @type {number}
         */
        this.gratuityMinorUnits = 0;

        /**
         * @type {string|null}
         */
        this.thirdPartyID = null;

        /**
         * Is the transaction complete?
         *
         * @type {boolean}
         */
        this.isFinished = false;

        /**
         * Did we receive an error response.
         *
         * @type {boolean}
         */
        this.hasError = false;

        /**
         * When status === TRANSACTION_FINISHED what is the result?
         * See DojoTransactionResultStatus.js
         *
         * @type {{message: ?string}}
         */
        this.transactionResult = {
            message: null,
            status: null,
        };
    }

    isSale() {
        return this.type === DojoWebPosTransactionType.SALE;
    }

    addGratuity(amountInMinorUnits) {
        if (typeof amountInMinorUnits !== 'number' || amountInMinorUnits < 0) {
            throw new Error('DojoWebPosTransaction requires gratuity to be a positive number');
        }

        this.gratuityMinorUnits = amountInMinorUnits;
        this.gratuityMajorUnits = fromMinorUnit(amountInMinorUnits);
    }

    setResponseAmount(amountInMinorUnits) {
        if (typeof amountInMinorUnits !== 'number' || amountInMinorUnits < 0) {
            throw new Error('DojoWebPosTransaction requires amount to be a positive number');
        }
        this.amountMinorUnits = amountInMinorUnits;
        this.amountMajorUnits = fromMinorUnit(amountInMinorUnits);
    }

    /**
     * The only possible values for result should be success and failure.
     *
     * @param {string} result
     */
    setTransactionResult(result) {
        this.transactionResult.status = result === DojoWebPosResult.SUCCESS ? DojoWebPosResult.SUCCESS : DojoWebPosResult.FAILURE;

        this.transactionResult.message = 'Failure';
        if (result === DojoWebPosResult.SUCCESS) {
            this.transactionResult.message = 'Success';
        }
    }
}

module.exports = DojoWebPosTransaction;
